<template>
  <div>
    <div class="auto-renew-wrapper mbottom-20" v-if="isShowAutoRenew">
      <p class="field-error" :class="{ 'show-error' : isError }">Grr... You must accept TunnelBear’s Auto-renew Policy.</p>
      <label for="auto-renew" class="checkbox">
        <input type="checkbox" id="auto-renew" name="auto-renew" @change="onAutoRenewCheckboxChange()">
        <span class="check"></span>
        <p>I have read and accept TunnelBear's  <router-link :to="{name: 'autorenew-policy'}" target="_blank"> Auto-renew Policy</router-link></p>
      </label>
    </div>
    <p class="fine-print-lg mbottom-20">
      By clicking <strong>{{ buttonLabel }}</strong>,
      you accept the <router-link :to="{name: 'terms-of-service'}" target="_blank">Terms Service</router-link>
      and <router-link :to="{name: 'privacy-policy'}" target="_blank">Privacy Policy</router-link>.</p>
  </div>
</template>

<script>
import products from '@/data/product-details.js'

export default {
  name: 'payment-agreement',
  data () {
    return {
      products,
      isAutoRenewChecked: false,
      isError: null
    }
  },
  props: {
    'config': Object,
    buttonLabel: {
      type: String,
      default: 'Buy Now'
    }
  },
  computed: {
    isShowAutoRenew: function () {
      const product = this.products[this.config.productName]
      return product.name !== 'threeyear' && product.name !== 'gotb'
    }
  },
  methods: {
    onAutoRenewCheckboxChange: function () {
      this.isAutoRenewChecked = !this.isAutoRenewChecked
      if (this.isAutoRenewChecked) {
        this.isError = false
      }
    },
    validateAutoRenewCheck: function () {
      let isValidate = true
      const product = this.products[this.config.productName]
      const isNotAutRenewPlan = product.name !== 'threeyear' && product.name !== 'gotb'
      if (!this.isAutoRenewChecked && isNotAutRenewPlan) {
        this.isError = true
        isValidate = false
      } else {
        this.isError = false
      }
      return isValidate
    }
  }
}
</script>
<style lang="stylus" src="./payment-agreement.styl" scoped></style>
